import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export default function SortBar({ sortBy, setSortBy }) {
  return (
    <Box sx={{ marginBottom: 3 }}>
      <FormControl fullWidth>
        <InputLabel>Sort By</InputLabel>
        <Select
          value={sortBy}
          label="Sort By"
          onChange={(e) => setSortBy(e.target.value)}
        >
          <MenuItem value="">None</MenuItem>

          <MenuItem value="name-asc">Name (A → Z)</MenuItem>
          <MenuItem value="name-desc">Name (Z → A)</MenuItem>

          <MenuItem value="rank-asc">Crunchbase Rank (Low → High)</MenuItem>
          <MenuItem value="rank-desc">Crunchbase Rank (High → Low)</MenuItem>

          <MenuItem value="employees-desc">Employees (High → Low)</MenuItem>
          <MenuItem value="employees-asc">Employees (Low → High)</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
